import { render, staticRenderFns } from "./AnimatingTextComponent.vue?vue&type=template&id=275a086e"
import script from "./AnimatingTextComponent.vue?vue&type=script&lang=js"
export * from "./AnimatingTextComponent.vue?vue&type=script&lang=js"
import style0 from "./AnimatingTextComponent.vue?vue&type=style&index=0&id=275a086e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports